import Chip from './chip'

import type { JSX } from 'react'

/** Keys are the search store's field names (`nextSearch.fullTime`, …). */
const JOB_TYPE_FILTERS = [
  { key: 'fullTime', label: 'Full-time' },
  { key: 'partTime', label: 'Part-time' },
  { key: 'noExperience', label: 'No experience' },
  { key: 'remote', label: 'Remote' },
]

type FilterChipsProps = {
  value: string[]
  onChange: (value: string[]) => void
}

export default function FilterChips({ value, onChange }: FilterChipsProps): JSX.Element {
  const toggle = (key: string): void => onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key])

  return (
    <div role="group" aria-label="Job type" className="flex flex-wrap gap-2">
      {JOB_TYPE_FILTERS.map(({ key, label }) => {
        const pressed = value.includes(key)

        return (
          <Chip
            key={key}
            interactive
            variant={pressed ? 'accent' : 'default'}
            aria-pressed={pressed}
            onClick={() => toggle(key)}
          >
            {pressed && (
              // A cue beyond colour: the two chip fills are only ~1.2:1 apart.
              <svg
                aria-hidden="true"
                viewBox="0 0 16 16"
                className="size-3.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M3 8.5l3.5 3.5L13 5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
            {label}
          </Chip>
        )
      })}
    </div>
  )
}
